import React, { Component, Fragment } from 'react';

import { Link } from 'react-router-dom';

import cs from 'classnames';
import ForwardIcon from '@mui/icons-material/Forward';
import { ListItem, ListItemText, ListItemSecondaryAction } from '@mui/material';
import { bool, func } from 'prop-types';

import FiberNewIcon from '../../components/FiberNewIcon';
import { NOTICE_TYPES } from '../../constants/Values';
import { splitPreambleAndYaml, parseDiversionYaml } from '../../util/diversion';
import IntlMessages, { SimpleText } from '../../util/IntlMessages';
import { templateType } from './types';

class TemplatesListItem extends Component {
  static propTypes = {
    onTemplateClick: func,
    selected: bool,
    template: templateType.isRequired,
    isTemplate: bool,
  };

  static defaultProps = {
    onTemplateClick: () => {},
    selected: false,
    isTemplate: false,
  };

  shouldComponentUpdate(nextProps) {
    return this.props.template !== nextProps.template || this.props.selected !== nextProps.selected;
  }

  onTemplateClick = template => () => this.props.onTemplateClick(template);

  getLocation = () => window.location.hash;

  // For DIVERSION templates, parse the body and render a tidy summary instead
  // of the raw preamble + YAML. Mirrors NoticesListItem.renderDiversionSummary
  // so the sidebar preview reads the same way as the inbox row preview for
  // the same data shape. Falls back to the raw body on parse failure
  // (defensive — a malformed template should still show something).
  renderTemplateSecondary = () => {
    const { template } = this.props;
    if (template.type !== NOTICE_TYPES.DIVERSION || !template.body) return template.body;

    const [preamble, yamlText] = splitPreambleAndYaml(template.body);
    const parsed = parseDiversionYaml(yamlText);

    const parseFailed = !yamlText || (Object.keys(parsed).length === 0 && template.body);
    if (parseFailed) return template.body;

    const firstLineOfPreamble =
      (preamble || '')
        .split('\n')
        .map(s => s.trim())
        .find(s => s.length > 0) || '';

    if (parsed.cancel === true) {
      return (
        <Fragment>
          <SimpleText id="diversion.template.summary.cancelled" />
          {firstLineOfPreamble ? ` — ${firstLineOfPreamble}` : ''}
        </Fragment>
      );
    }

    const shelters = Array.isArray(parsed.shelters) ? parsed.shelters : [];
    const count = shelters.length;
    return (
      <Fragment>
        <IntlMessages id="diversion.template.summary.n-shelters" values={{ count }} />
        {firstLineOfPreamble ? ` — ${firstLineOfPreamble}` : ''}
      </Fragment>
    );
  };

  render() {
    const { selected, template, isTemplate } = this.props;
    const secondary = this.renderTemplateSecondary();
    return (
      <Fragment>
        {isTemplate ? (
          <ListItem
            button
            component={Link}
            to={`/notices/templates/${template.id}`}
            onClick={this.onTemplateClick(template)}
            className={cs({ selected })}
            sx={{ borderBottom: 1, borderColor: 'divider' }}
          >
            <ListItemText primary={template.header} secondary={secondary} />
            <ListItemSecondaryAction className="template-item-icon">
              {template.new && <FiberNewIcon />}
              <ForwardIcon />
            </ListItemSecondaryAction>
          </ListItem>
        ) : (
          <ListItem
            button
            onClick={this.onTemplateClick(template)}
            className={cs({ selected })}
            sx={{ borderBottom: 1, borderColor: 'divider' }}
          >
            <ListItemText primary={template.header} secondary={secondary} />
            <ListItemSecondaryAction className="template-item-icon">
              {template.new && <FiberNewIcon />}
              <ForwardIcon />
            </ListItemSecondaryAction>
          </ListItem>
        )}
      </Fragment>
    );
  }
}

export default TemplatesListItem;
